export default {
  default: () => import("/builds/webcontact/engelsbrand/layouts/default.vue"),
  grundschule: () => import("/builds/webcontact/engelsbrand/layouts/grundschule.vue")
}